"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
const rotate = (0, styles_1.keyframes) `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const Loader = (0, styles_1.styled)("div", {
    shouldForwardProp: (prop) => prop !== "height" && prop !== "width",
})(({ theme, width, height }) => ({
    border: "8px solid #f3f3f3",
    borderRadius: "50%",
    borderTop: `8px solid ${theme.palette.institutional.braskemBlue}`,
    width: width || 80,
    height: height || 80,
    animation: `${rotate} 2s linear infinite`,
}));
exports.default = Loader;
